import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import upperCase from 'lodash/upperCase'

import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'

import { EmployeeAvatar } from 'modules/employees/components/EmployeeAvatar'
import { useCurrentViewOptions } from 'modules/shift_management/hooks/useCurrentViewOptions'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import ShiftsRowCheckbox from '../EmployeeInfoCell/ShiftsRowCheckbox'
import HoursInformation from './HoursInformation'

interface Props {
  shiftsRow: ShiftsRow
}

/**
 *
 * @deprecated Use EmployeeInfoCell instead, this is not used anymore.
 */
const EmployeeCellContent = ({ shiftsRow }: Props) => {
  const { viewOptions } = useCurrentViewOptions()
  const {
    employee: { showJobPosition },
  } = viewOptions

  return (
    <Box width="full">
      <Box
        flexDirection="row"
        gap="s8"
        width="full"
        justifyContent="spaceBetween"
        alignItems="flexStart"
      >
        <Box flexDirection="row" gap="s8" flexGrow minWidth="s0">
          {shiftsRow.avatar ? (
            <EmployeeAvatar
              variant="medium"
              employee={{
                id: shiftsRow.id,
                access: {
                  id: shiftsRow.id,
                  fullName: shiftsRow.title,
                  avatar: shiftsRow.avatar,
                },
              }}
            />
          ) : (
            <Avatar size="s32" url={buildUrl(shiftsRow.avatar)} label={shiftsRow.title} />
          )}
          <Box gap="s6" flexGrow minWidth="s0">
            <Box gap="s4" minWidth="s0">
              <Text size="200" weight="semibold" color="grey1000" ellipsis>
                {shiftsRow.title}
              </Text>
              {showJobPosition && (
                <Text size="100" color="grey1000" ellipsis>
                  {upperCase(shiftsRow.job)}
                </Text>
              )}
            </Box>
            <HoursInformation shiftsRow={shiftsRow} />
          </Box>
        </Box>
        <Box flexNoShrink>
          <ShiftsRowCheckbox shiftsRow={shiftsRow} />
        </Box>
      </Box>
    </Box>
  )
}

export default observer(EmployeeCellContent)
